import { isAction, type Middleware } from '@reduxjs/toolkit';

import { captureBusinessEvent } from '@/shared/utils/posthogEvents';

import { posthogBusinessEvents } from './posthogBusinessEvents';

export const posthogAnalyticsMiddleware: Middleware = () => (next) => (action) => {
  const result = next(action);

  // `Object.hasOwn` e não `in`: um type como `toString` acharia a chave no protótipo do objeto.
  if (
    typeof window === 'undefined' ||
    !isAction(action) ||
    !Object.hasOwn(posthogBusinessEvents, action.type)
  ) {
    return result;
  }

  try {
    captureBusinessEvent(posthogBusinessEvents[action.type]);
  } catch {
    // Analytics nunca derruba a operação: o reducer já rodou e quem despachou espera o resultado.
  }

  return result;
};
